module.exports = __webpack_public_path__ + "img/center01.b7cb208d.webp";